import {
  getGochiMenusData,
  getGroupMenusData,
  getGochiMenuDetailData,
  addGochiMenuData,
  editGochiMenuData,
  editOrderGochiMenusData,
  deleteGochiMenuData,
  showHideGochiMenuData,
  ignoreGochiMenuData,
  addGochiMenuImageData,
  downloadMenuData,
  createSecretMenuData,
  changeShashokuOptionData,
  getMenuOneToNData,
  addMenuEventData,
  deleteMenuEventData,
  getMenuSettingData,
  // addMenuSettingData,
  editMenuSettingData,
  getChargeAmountData,
  postBudgetGochiData,
  addGochiKidMenuData,
  removeGochiKidMenuData,
  getGochiKidMenusData,
  downloadGochiKidMenusData,
  getMenuImageSampleData,
  getSettingMenuFreeData,
  settingMenuFreeData,
  deleteSettingMenuFreeData,
  getListSettingMenuFreeData
} from '../libs/apis/GochiMenuApi';

export const GET_GOCHI_MENUS_REQUEST = 'GET_GOCHI_MENUS_REQUEST';
export const GET_GOCHI_MENUS_SUCCESS = 'GET_GOCHI_MENUS_SUCCESS';
export const GET_GOCHI_MENUS_FAILURE = 'GET_GOCHI_MENUS_FAILURE';

export const GET_GROUP_MENUS_REQUEST = 'GET_GROUP_MENUS_REQUEST';
export const GET_GROUP_MENUS_SUCCESS = 'GET_GROUP_MENUS_SUCCESS';
export const GET_GROUP_MENUS_FAILURE = 'GET_GROUP_MENUS_FAILURE';

export const GET_CHARGE_AMOUNT_REQUEST = 'GET_CHARGE_AMOUNT_REQUEST';
export const GET_CHARGE_AMOUNT_SUCCESS = 'GET_CHARGE_AMOUNT_SUCCESS';
export const GET_CHARGE_AMOUNT_FAILURE = 'GET_CHARGE_AMOUNT_FAILURE';

export const POST_BUDGET_GOCHI_REQUEST = 'POST_BUDGET_GOCHI_REQUEST';
export const POST_BUDGET_GOCHI_SUCCESS = 'POST_BUDGET_GOCHI_SUCCESS';
export const POST_BUDGET_GOCHI_FAILURE = 'POST_BUDGET_GOCHI_FAILURE';

export const GET_ORDER_GOCHI_MENUS_REQUEST = 'GET_ORDER_GOCHI_MENUS_REQUEST';
export const GET_ORDER_GOCHI_MENUS_SUCCESS = 'GET_ORDER_GOCHI_MENUS_SUCCESS';
export const GET_ORDER_GOCHI_MENUS_FAILURE = 'GET_ORDER_GOCHI_MENUS_FAILURE';
export const CLEAR_ORDER_GOCHI_MENUS = 'CLEAR_ORDER_GOCHI_MENUS';

export const GET_GOCHI_MENU_DETAIL_REQUEST = 'GET_GOCHI_MENU_DETAIL_REQUEST';
export const GET_GOCHI_MENU_DETAIL_SUCCESS = 'GET_GOCHI_MENU_DETAIL_SUCCESS';
export const GET_GOCHI_MENU_DETAIL_FAILURE = 'GET_GOCHI_MENU_DETAIL_FAILURE';

export const ADD_GOCHI_MENU_REQUEST = 'ADD_GOCHI_MENU_REQUEST';
export const ADD_GOCHI_MENU_SUCCESS = 'ADD_GOCHI_MENU_SUCCESS';
export const ADD_GOCHI_MENU_FAILURE = 'ADD_GOCHI_MENU_FAILURE';

export const EDIT_GOCHI_MENU_REQUEST = 'EDIT_GOCHI_MENU_REQUEST';
export const EDIT_GOCHI_MENU_SUCCESS = 'EDIT_GOCHI_MENU_SUCCESS';
export const EDIT_GOCHI_MENU_FAILURE = 'EDIT_GOCHI_MENU_FAILURE';

export const EDIT_ORDER_GOCHI_MENU_REQUEST = 'EDIT_ORDER_GOCHI_MENU_REQUEST';
export const EDIT_ORDER_GOCHI_MENU_SUCCESS = 'EDIT_ORDER_GOCHI_MENU_SUCCESS';
export const EDIT_ORDER_GOCHI_MENU_FAILURE = 'EDIT_ORDER_GOCHI_MENU_FAILURE';

export const DELETE_GOCHI_MENU_REQUEST = 'DELETE_GOCHI_MENU_REQUEST';
export const DELETE_GOCHI_MENU_SUCCESS = 'DELETE_GOCHI_MENU_SUCCESS';
export const DELETE_GOCHI_MENU_FAILURE = 'DELETE_GOCHI_MENU_FAILURE';

export const SHOW_HIDE_GOCHI_MENU_REQUEST = 'SHOW_HIDE_GOCHI_MENU_REQUEST';
export const SHOW_HIDE_GOCHI_MENU_SUCCESS = 'SHOW_HIDE_GOCHI_MENU_SUCCESS';
export const SHOW_HIDE_GOCHI_MENU_FAILURE = 'SHOW_HIDE_GOCHI_MENU_FAILURE';

export const IGNORE_GOCHI_MENU_REQUEST = 'IGNORE_GOCHI_MENU_REQUEST';
export const IGNORE_GOCHI_MENU_SUCCESS = 'IGNORE_GOCHI_MENU_SUCCESS';
export const IGNORE_GOCHI_MENU_FAILURE = 'IGNORE_GOCHI_MENU_FAILURE';

export const CHANGE_SHASHOKU_OPTION_REQUEST = 'CHANGE_SHASHOKU_OPTION_REQUEST';
export const CHANGE_SHASHOKU_OPTION_SUCCESS = 'CHANGE_SHASHOKU_OPTION_SUCCESS';
export const CHANGE_SHASHOKU_OPTION_FAILURE = 'CHANGE_SHASHOKU_OPTION_FAILURE';

export const ADD_GOCHI_MENU_IMAGE_REQUEST = 'ADD_GOCHI_MENU_IMAGE_REQUEST';
export const ADD_GOCHI_MENU_IMAGE_SUCCESS = 'ADD_GOCHI_MENU_IMAGE_SUCCESS';
export const ADD_GOCHI_MENU_IMAGE_FAILURE = 'ADD_GOCHI_MENU_IMAGE_FAILURE';

export const DOWNLOAD_GOCHI_MENU_REQUEST = 'DOWNLOAD_GOCHI_MENU_REQUEST';
export const DOWNLOAD_GOCHI_MENU_SUCCESS = 'DOWNLOAD_GOCHI_MENU_SUCCESS';
export const DOWNLOAD_GOCHI_MENU_FAILURE = 'DOWNLOAD_GOCHI_MENU_FAILURE';

export const GET_MENU_ONE_TO_N_REQUEST = 'GET_MENU_ONE_TO_N_REQUEST';
export const GET_MENU_ONE_TO_N_SUCCESS = 'GET_MENU_ONE_TO_N_SUCCESS';
export const GET_MENU_ONE_TO_N_FAILURE = 'GET_MENU_ONE_TO_N_FAILURE';

export const ADD_MENU_EVENT_REQUEST = 'ADD_MENU_EVENT_REQUEST';
export const ADD_MENU_EVENT_SUCCESS = 'ADD_MENU_EVENT_SUCCESS';
export const ADD_MENU_EVENT_FAILURE = 'ADD_MENU_EVENT_FAILURE';

export const DELETE_MENU_EVENT_REQUEST = 'DELETE_MENU_EVENT_REQUEST';
export const DELETE_MENU_EVENT_SUCCESS = 'DELETE_MENU_EVENT_SUCCESS';
export const DELETE_MENU_EVENT_FAILURE = 'DELETE_MENU_EVENT_FAILURE';

export const CREATE_SECRET_GOCHI_MENU_REQUEST =
  'CREATE_SECRET_GOCHI_MENU_REQUEST';
export const CREATE_SECRET_GOCHI_MENU_SUCCESS =
  'CREATE_SECRET_GOCHI_MENU_SUCCESS';
export const CREATE_SECRET_GOCHI_MENU_FAILURE =
  'CREATE_SECRET_GOCHI_MENU_FAILURE';

export const GET_MENU_SETTING_REQUEST = 'GET_MENU_SETTING_REQUEST';
export const GET_MENU_SETTING_SUCCESS = 'GET_MENU_SETTING_SUCCESS';
export const GET_MENU_SETTING_FAILURE = 'GET_MENU_SETTING_FAILURE';

// export const ADD_MENU_SETTING_REQUEST = 'ADD_MENU_SETTING_REQUEST';
// export const ADD_MENU_SETTING_SUCCESS = 'ADD_MENU_SETTING_SUCCESS';
// export const ADD_MENU_SETTING_FAILURE = 'ADD_MENU_SETTING_FAILURE';

export const UPDATE_MENU_SETTING_REQUEST = 'UPDATE_MENU_SETTING_REQUEST';
export const UPDATE_MENU_SETTING_SUCCESS = 'UPDATE_MENU_SETTING_SUCCESS';
export const UPDATE_MENU_SETTING_FAILURE = 'UPDATE_MENU_SETTING_FAILURE';

export const ADD_GOCHI_KID_MENU_REQUEST = 'ADD_GOCHI_KID_MENU_REQUEST';
export const ADD_GOCHI_KID_MENU_SUCCESS = 'ADD_GOCHI_KID_MENU_SUCCESS';
export const ADD_GOCHI_KID_MENU_FAILURE = 'ADD_GOCHI_KID_MENU_FAILURE';

export const REMOVE_GOCHI_KID_MENU_REQUEST = 'REMOVE_GOCHI_KID_MENU_REQUEST';
export const REMOVE_GOCHI_KID_MENU_SUCCESS = 'REMOVE_GOCHI_KID_MENU_SUCCESS';
export const REMOVE_GOCHI_KID_MENU_FAILURE = 'REMOVE_GOCHI_KID_MENU_FAILURE';

export const GET_MENU_IMAGE_REQUEST = 'GET_MENU_IMAGE_REQUEST';
export const GET_MENU_IMAGE_SUCCESS = 'GET_MENU_IMAGE_SUCCESS';
export const GET_MENU_IMAGE_FAILURE = 'GET_MENU_IMAGE_FAILURE';

export const GET_SETTING_MENU_FREE_REQUEST = 'GET_SETTING_MENU_FREE_REQUEST';
export const GET_SETTING_MENU_FREE_SUCCESS = 'GET_SETTING_MENU_FREE_SUCCESS';
export const GET_SETTING_MENU_FREE_FAILURE = 'GET_SETTING_MENU_FREE_FAILURE';

export const SETTING_MENU_FREE_REQUEST = 'SETTING_MENU_FREE_REQUEST';
export const SETTING_MENU_FREE_SUCCESS = 'SETTING_MENU_FREE_SUCCESS';
export const SETTING_MENU_FREE_FAILURE = 'SETTING_MENU_FREE_FAILURE';

export const DELETE_SETTING_MENU_FREE_REQUEST =
  'DELETE_SETTING_MENU_FREE_REQUEST';
export const DELETE_SETTING_MENU_FREE_SUCCESS =
  'DELETE_SETTING_MENU_FREE_SUCCESS';
export const DELETE_SETTING_MENU_FREE_FAILURE =
  'DELETE_SETTING_MENU_FREE_FAILURE';

export const GET_LIST_SETTING_MENU_FREE_REQUEST =
  'GET_LIST_SETTING_MENU_FREE_REQUEST';
export const GET_LIST_SETTING_MENU_FREE_SUCCESS =
  'GET_LIST_SETTING_MENU_FREE_SUCCESS';
export const GET_LIST_SETTING_MENU_FREE_FAILURE =
  'GET_LIST_SETTING_MENU_FREE_FAILURE';

export const getMenuSetting = params => dispatch => {
  dispatch({ type: GET_MENU_SETTING_REQUEST });
  return getMenuSettingData(params)
    .then(response =>
      dispatch({
        type: GET_MENU_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

// export const addMenuSetting = params => dispatch => {
//   dispatch({ type: ADD_MENU_SETTING_REQUEST });
//   return addMenuSettingData(params)
//     .then(response =>
//       dispatch({
//         type: ADD_MENU_SETTING_SUCCESS,
//         payload: response.data
//       })
//     )
//     .catch(error =>
//       dispatch({
//         type: ADD_MENU_SETTING_FAILURE,
//         payload: error.response,
//         error: true
//       })
//     );
// };

export const updateMenuSetting = params => dispatch => {
  dispatch({ type: UPDATE_MENU_SETTING_REQUEST });
  return editMenuSettingData(params)
    .then(response =>
      dispatch({
        type: UPDATE_MENU_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_MENU_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiMenus = params => dispatch => {
  dispatch({ type: GET_GOCHI_MENUS_REQUEST });
  return getGochiMenusData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_MENUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_MENUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupMenus = params => dispatch => {
  dispatch({ type: GET_GROUP_MENUS_REQUEST });
  return getGroupMenusData(params)
    .then(response =>
      dispatch({
        type: GET_GROUP_MENUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_MENUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getChargeAmount = params => dispatch => {
  dispatch({ type: GET_CHARGE_AMOUNT_REQUEST });
  return getChargeAmountData(params)
    .then(response =>
      dispatch({
        type: GET_CHARGE_AMOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_CHARGE_AMOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postBudgetGochi = params => dispatch => {
  dispatch({ type: POST_BUDGET_GOCHI_REQUEST });
  return postBudgetGochiData(params)
    .then(response =>
      dispatch({
        type: POST_BUDGET_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_BUDGET_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getOrderGochiMenus = params => dispatch => {
  dispatch({ type: GET_ORDER_GOCHI_MENUS_REQUEST });
  return getGochiMenusData(params)
    .then(response =>
      dispatch({
        type: GET_ORDER_GOCHI_MENUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_ORDER_GOCHI_MENUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const clearOrderGochiMenus = () => dispatch => {
  dispatch({ type: CLEAR_ORDER_GOCHI_MENUS });
};

export const getGochiMenuDetail = menuId => dispatch => {
  dispatch({ type: GET_GOCHI_MENU_DETAIL_REQUEST });
  return getGochiMenuDetailData(menuId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_MENU_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_MENU_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiMenu = params => dispatch => {
  dispatch({ type: ADD_GOCHI_MENU_REQUEST });
  return addGochiMenuData(params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGochiMenu = (menuId, params) => dispatch => {
  dispatch({ type: EDIT_GOCHI_MENU_REQUEST });
  return editGochiMenuData(menuId, params)
    .then(response =>
      dispatch({
        type: EDIT_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editOrderGochiMenus = params => dispatch => {
  dispatch({ type: EDIT_ORDER_GOCHI_MENU_REQUEST });
  return editOrderGochiMenusData(params)
    .then(response =>
      dispatch({
        type: EDIT_ORDER_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_ORDER_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGochiMenu = menuId => dispatch => {
  dispatch({ type: DELETE_GOCHI_MENU_REQUEST });
  return deleteGochiMenuData(menuId)
    .then(response =>
      dispatch({
        type: DELETE_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const showHideGochiMenu = (menuId, paramShowHide) => dispatch => {
  dispatch({ type: SHOW_HIDE_GOCHI_MENU_REQUEST });
  return showHideGochiMenuData(menuId, paramShowHide)
    .then(response =>
      dispatch({
        type: SHOW_HIDE_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SHOW_HIDE_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const ignoreGochiMenu = (menuId, isShow) => dispatch => {
  dispatch({ type: IGNORE_GOCHI_MENU_REQUEST });
  return ignoreGochiMenuData(menuId, isShow)
    .then(response =>
      dispatch({
        type: IGNORE_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: IGNORE_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const changeShashokuOption = (
  menuId,
  shashokuOn,
  gochimeshiOn
) => dispatch => {
  dispatch({ type: CHANGE_SHASHOKU_OPTION_REQUEST });
  return changeShashokuOptionData(menuId, shashokuOn, gochimeshiOn)
    .then(response =>
      dispatch({
        type: CHANGE_SHASHOKU_OPTION_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CHANGE_SHASHOKU_OPTION_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiMenuImage = (menuId, params) => dispatch => {
  dispatch({ type: ADD_GOCHI_MENU_IMAGE_REQUEST });
  return addGochiMenuImageData(menuId, params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_MENU_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_MENU_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadMenu = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHI_MENU_REQUEST });
  return downloadMenuData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const createSecretMenu = () => dispatch => {
  dispatch({ type: CREATE_SECRET_GOCHI_MENU_REQUEST });
  return createSecretMenuData()
    .then(response =>
      dispatch({
        type: CREATE_SECRET_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CREATE_SECRET_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenuOneToN = params => dispatch => {
  dispatch({ type: GET_MENU_ONE_TO_N_REQUEST });
  return getMenuOneToNData(params)
    .then(response =>
      dispatch({
        type: GET_MENU_ONE_TO_N_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_ONE_TO_N_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addMenuEvent = params => dispatch => {
  dispatch({ type: ADD_MENU_EVENT_REQUEST });
  return addMenuEventData(params)
    .then(response =>
      dispatch({
        type: ADD_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteMenuEvent = menuId => dispatch => {
  dispatch({ type: DELETE_MENU_EVENT_REQUEST });
  return deleteMenuEventData(menuId)
    .then(response =>
      dispatch({
        type: DELETE_MENU_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_MENU_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiKidMenu = (menuId, params) => dispatch => {
  dispatch({ type: ADD_GOCHI_KID_MENU_REQUEST });
  return addGochiKidMenuData(menuId, params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_KID_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_KID_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const removeGochiKidMenu = (menuId, params) => dispatch => {
  dispatch({ type: REMOVE_GOCHI_KID_MENU_REQUEST });
  return removeGochiKidMenuData(menuId, params)
    .then(response =>
      dispatch({
        type: REMOVE_GOCHI_KID_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: REMOVE_GOCHI_KID_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiKidMenus = params => dispatch => {
  dispatch({ type: GET_GOCHI_MENUS_REQUEST });
  return getGochiKidMenusData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_MENUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_MENUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochiKidMenus = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHI_MENU_REQUEST });
  return downloadGochiKidMenusData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHI_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_GOCHI_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getMenuImageSample = () => dispatch => {
  dispatch({ type: GET_MENU_IMAGE_REQUEST });
  return getMenuImageSampleData()
    .then(response =>
      dispatch({
        type: GET_MENU_IMAGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_MENU_IMAGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getSettingMenuFree = menuId => dispatch => {
  dispatch({ type: GET_SETTING_MENU_FREE_REQUEST });
  return getSettingMenuFreeData(menuId)
    .then(response =>
      dispatch({
        type: GET_SETTING_MENU_FREE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_SETTING_MENU_FREE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const settingMenuFree = (menuId, params) => dispatch => {
  dispatch({ type: SETTING_MENU_FREE_REQUEST });
  return settingMenuFreeData(menuId, params)
    .then(response =>
      dispatch({
        type: SETTING_MENU_FREE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SETTING_MENU_FREE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteSettingMenuFree = menuId => dispatch => {
  dispatch({ type: DELETE_SETTING_MENU_FREE_REQUEST });
  return deleteSettingMenuFreeData(menuId)
    .then(response =>
      dispatch({
        type: DELETE_SETTING_MENU_FREE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_SETTING_MENU_FREE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListSettingMenuFree = params => dispatch => {
  dispatch({ type: GET_LIST_SETTING_MENU_FREE_REQUEST });
  return getListSettingMenuFreeData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_SETTING_MENU_FREE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_SETTING_MENU_FREE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
